'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SeparatorStyled = undefined;

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactackleCore = require('reactackle-core');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var size = function size(_ref) {
  var themeFromProvider = _ref.theme;
  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
  var _theme$reactackle$com = theme.reactackle.components.breadcrumbs.item.separator,
      height = _theme$reactackle$com.height,
      width = _theme$reactackle$com.width,
      imgHeight = _theme$reactackle$com.imgHeight,
      imgWidth = _theme$reactackle$com.imgWidth,
      fontSize = _theme$reactackle$com.fontSize,
      marginY = _theme$reactackle$com.marginY,
      marginX = _theme$reactackle$com.marginX;
  return (0, _styledComponents.css)(['font-size:', ';line-height:', ';margin:', ' ', ';', ''], (0, _reactackleCore.getValueString)(fontSize), height, (0, _reactackleCore.getValueString)(marginY), (0, _reactackleCore.getValueString)(marginX), (0, _reactackleCore.iconSizeMixin)((0, _reactackleCore.getValueString)(height), (0, _reactackleCore.getValueString)(imgHeight || height), (0, _reactackleCore.getValueString)(width || height), (0, _reactackleCore.getValueString)(imgWidth || imgHeight || height)));
};

var colorScheme = function colorScheme(_ref2) {
  var colorScheme = _ref2.colorScheme,
      themeFromProvider = _ref2.theme;
  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
  var path = theme.reactackle.components.breadcrumbs.item.separator;
  return '\n    opacity: ' + path.opacity + ';\n    color: ' + path.colorScheme[colorScheme].color + ';\n    fill: ' + path.colorScheme[colorScheme].color + ';\n  ';
};

var SeparatorStyled = exports.SeparatorStyled = _styledComponents2.default.div.withConfig({
  displayName: 'SeparatorStyled'
})(['display:inline-flex;align-items:center;text-align:center;', ' ', ' li:last-child &{display:none;pointer-events:none;position:fixed;width:0;height:0;}'], size, colorScheme);